import { render, staticRenderFns } from "./CmAccordion.vue?vue&type=template&id=7471e55a"
import script from "./CmAccordion.vue?vue&type=script&lang=ts"
export * from "./CmAccordion.vue?vue&type=script&lang=ts"
import style0 from "./CmAccordion.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,Collapsible: require('/app/components/base/Collapsible/Collapsible.vue').default})
